import { ovl } from "../../../../../../src"
import { DialogClose } from "../../../../../../src/library/dialog/dialogapi"
import { FormGet } from "../../../../../../src/library/forms/formapi"
import {
  SYSTableDef,
  TableColumnFilter,
  TableGet,
  TableRebuild,
} from "../../../../../../src/library/table/tableapi"
import { HeaderMenuFilterFieldsSetState } from "../../../../../../src/library/table/tablerowheadermenu/tablesettings/hookactions"
import { SYSTableSettings_ColumnFilter } from "./tabledef"

// used for fast value retrieve in GetValue Hook
let _BaseTableContextForColumnFilter = {
  tableDef: <SYSTableDef>undefined,
  rows: undefined,
  columnKey: "",
  additionalColumnKey: "",
  isList: false,
  isCalculated: false,
}

export const _SetFilter = async (exclusive: boolean, filterVal = undefined) => {
  let list: any[] = []
  if (filterVal !== undefined) {
    list = [filterVal]
  } else {
    let filtered = TableGet<SYSTableSettings_ColumnFilter>(
      "SYSTableSettings_ColumnFilter",
      { byKeys: "Selected" }
    )
    let filteredKeys = filtered.getKeys()
    filteredKeys.forEach((k) => {
      let code = filtered.rows[k].RawValForFilter
      list.push(code)
    })
  }
  let tableDef = TableGet(
    ovl.getState().ovl.libState.tableSettings.columnFilter.defId
  )
  let columnKey =
    ovl.getState().ovl.libState.tableSettings.columnFilter.columnKey
  if (
    await TableColumnFilter(tableDef.def.id, columnKey, list, {
      exclusive,
      _innerEvent: true,
    })
  ) {
    await TableRebuild(tableDef.def.id, { showProcess: true })
    HeaderMenuFilterFieldsSetState(
      FormGet("SYSHeaderMenuFilter", { instance: "1" }).formState
    )
  }
  DialogClose("SYSTableSettings_ColumnFilter")
}

export { _BaseTableContextForColumnFilter }
